module.exports = __webpack_public_path__ + "media/images/mercado_pago-93f6b769da26d90eb587537e3d896581.png";